var _classCallCheck = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/createClass");

// Generated by CoffeeScript 2.4.1
(function () {
  // Represents a list of string entries
  var XMLDOMStringList;

  module.exports = XMLDOMStringList = function () {
    var XMLDOMStringList =
    /*#__PURE__*/
    function () {
      "use strict";

      // Initializes a new instance of `XMLDOMStringList`
      // This is just a wrapper around an ordinary
      // JS array.
      // `arr` the array of string values
      function XMLDOMStringList(arr) {
        _classCallCheck(this, XMLDOMStringList);

        this.arr = arr || [];
      } // Returns the indexth item in the collection.
      // `index` index into the collection


      _createClass(XMLDOMStringList, [{
        key: "item",
        value: function item(index) {
          return this.arr[index] || null;
        } // Test if a string is part of this DOMStringList.
        // `str` the string to look for

      }, {
        key: "contains",
        value: function contains(str) {
          return this.arr.indexOf(str) !== -1;
        }
      }]);

      return XMLDOMStringList;
    }();

    ; // Returns the number of strings in the list.

    Object.defineProperty(XMLDOMStringList.prototype, 'length', {
      get: function get() {
        return this.arr.length;
      }
    });
    return XMLDOMStringList;
  }.call(this);
}).call(this);